import {
  getLevelList,
  getEducationTypeList,
  getPaidList,
  getCountries,
  getStates,
  getCities,
  getDayList,
  getCenterList,
  getPeriodListByCenterId,
  getStudentSelectionList,
  //Dönem işlemleri
  addPeriod,
  updatePeriod,
  deletePeriod,
  //Userlist
  getUserCenterList,
  getUserPeriodListByCenterId,
} from "@/services/filter.service";

import { formatDateEdit } from "@/utils/utils";

// initial state
const state = () => ({
  centerId: null,
  centerPeriodId: null,

  levelList: [],
  educationTypeList: [],
  paidList: [],
  countryList: [],
  stateList: [],
  cityList: [],
  dayList: [],
  centerList: [],
  periodList: [],
  studentSelectionList: [],
});

// mutations
const mutations = {
  setLevelList(state, data) {
    state.levelList = data;
  },
  setEducationTypeList(state, data) {
    state.educationTypeList = data;
  },
  setPaidList(state, data) {
    state.paidList = data;
  },
  setCountryList(state, data) {
    state.countryList = data;
  },
  setStateList(state, data) {
    state.stateList = data;
  },
  setCityList(state, data) {
    state.cityList = data;
  },
  setDayList(state, data) {
    state.dayList = data;
  },

  setCenterList(state, data) {
    state.centerList = data;
  },
  setCenterId(state, data) {
    state.centerId = data;
  },

  setPeriodList(state, data) {
    state.periodList = data;
  },
  setCenterPeriodId(state, data) {
    state.centerPeriodId = data;
  },

  setStudentSelectionList(state, data) {
    state.studentSelectionList = data;
  },
};

// actions
const actions = {
  //Level Listesi
  async loadLevelList(vuexContext) {
    return await getLevelList().then((response) => {
      let data = response.data.data;
      data.map((level, index) => {
        level.value = level.id;
        level.index = index + 1;
        level.label = level.description;
      });
      vuexContext.commit("setLevelList", data);
      return data;
    });
  },

  //Öğrenim Türü Listesi
  async loadEducationTypeList(vuexContext) {
    return await getEducationTypeList().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.value = item.id;
        item.index = index + 1;
        item.label = item.name;
      });
      vuexContext.commit("setEducationTypeList", data);
      return data;
    });
  },

  //Ücret Türü Listesi
  async loadPaidList(vuexContext) {
    return await getPaidList().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.value = item.id;
        item.index = index + 1;
        item.label = item.name;
      });
      vuexContext.commit("setPaidList", data);
      return data;
    });
  },

  //Ülke Listesi
  async loadCountryList(vuexContext) {
    return await getCountries().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      vuexContext.commit("setCountryList", data);
      return data;
    });
  },

  //Eyalet Listesi
  async loadStateListByCountryId(vuexContext, countryId) {
    return await getStates(countryId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      vuexContext.commit("setStateList", data);
      return data;
    });
  },

  //Şehir Listesi
  async loadCityListByStateId(vuexContext, stateId) {
    return await getCities(stateId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      vuexContext.commit("setCityList", data);
      return data;
    });
  },

  //Gün Listesi
  async loadDayList(vuexContext) {
    return await getDayList().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      vuexContext.commit("setDayList", data);
      return data;
    });
  },

  //Merkez Listesi
  async loadCenterList() {
    return await getCenterList().then((response) => {
      let data = response.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      // vuexContext.commit("setCenterList", data);
      return data;
    });
  },

  //Merkez Id ile Dönem Listesi
  async loadPeriodListByCenterId(vuexContext, centerId) {
    return await getPeriodListByCenterId(centerId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      // vuexContext.commit("setPeriodList", data);
      return data;
    });
  },

  //Merkez Listesi
  async loadUserCenterList() {
    return await getUserCenterList().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      // vuexContext.commit("setCenterList", data);
      return data;
    });
  },

  //Merkez Id ile Dönem Listesi
  async loadUserPeriodListByCenterId(vuexContext, centerId) {
    return await getUserPeriodListByCenterId(centerId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
        item.startingDate = formatDateEdit(item.startingDate);
        item.endDate = formatDateEdit(item.endDate);
        item.registerStartDate = formatDateEdit(item.registerStartDate);
        item.registerEndDate = formatDateEdit(item.registerEndDate);
      });
      // vuexContext.commit("setPeriodList", data);
      return data;
    });
  },

  //Dönem Ekleme
  async addPeriod(vuexContext, periodModel) {
    return await addPeriod(periodModel);
  },
  //Dönem Update
  async updatePeriod(vuexContext, periodModel) {
    return await updatePeriod(periodModel);
  },
  //dönem Silme
  async deletePeriod(vuexContext, periodId) {
    return await deletePeriod(periodId);
  },

  async loadStudentSelectionList(vuexContext) {
    return await getStudentSelectionList().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      vuexContext.commit("setStudentSelectionList", data);
      return data;
    });
  },

  addStateList(vuexContext, data) {
    vuexContext.commit("setStateList", data);
  },
  addCityList(vuexContext, data) {
    vuexContext.commit("setCityList", data);
  },
  addCenterId(vuexContext, data) {
    vuexContext.commit("setCenterId", data);
  },
  addCenterPeriodId(vuexContext, data) {
    vuexContext.commit("setCenterPeriodId", data);
  },

  addDayList(vuexContext, data) {
    vuexContext.commit("setDayList", data);
  },

  addPeriodList(vuexContext, data) {
    vuexContext.commit("setPeriodList", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
